<template>
  <div class="footer">
    <div class="footerCon minBox">
      <div class="companyInfo">
        <div class="companyInfoTitle">联系我们</div>
        <div class="companyInfoItem">邮箱：admin@51ysscw.com</div>
        <div class="companyInfoItem">电话：<span>13065706575</span></div>
        <div class="companyInfoItem">地址：杭州市上城区同协金座13幢14F</div>
      </div>
      <div class="footerQRcode">
        <div class="QRcodeItem">
          <div class="img"><img src="~@/assets/img/footer/qrCode1.png" alt=""></div>
          <div class="text">微信公众号</div>
        </div>
        <div class="QRcodeItem">
          <div class="img"><img src="~@/assets/img/footer/qrCode2.png" alt=""></div>
          <div class="text">iOS下载</div>
        </div>
        <div class="QRcodeItem">
          <div class="img"><img src="~@/assets/img/footer/qrCode3.png" alt=""></div>
          <div class="text">Android下载</div>
        </div>
      </div>
      <div class="footerCopyInfo">Copyright © 2019 杭州凌浩网络科技有限公司 All Rights Reserved&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" target="_blank" class="bei">浙ICP备17047717号-1</a></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'footerCom',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.footer{
  width: 100%;
  height: 260px;
  background: #ccc;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 10;
  background: url("~@/assets/img/footerBg.png") no-repeat center;
  background-size: cover;
  .footerCon{
    height: 100%;
    overflow: hidden;
    .companyInfo{
      color: #fff;
      .companyInfoTitle{
        width: 80px;
        border-bottom: 2px solid #F2F2F2;
        font-size: 16px;
        line-height: 36px;
        margin-top: 30px;
      }
      .companyInfoItem{
        font-size: 14px;
        margin-top: 16px;
        span{
          font-size: 18px;
        }
      }
    }
    .footerQRcode{
      position: absolute;
      top: 38px;
      right: 0;
      display: flex;
      .QRcodeItem{
        margin-left: 20px;
        .img{
          width: 120px;
          height: 120px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .text{
          text-align: center;
          color: #F2F2F2;
          font-size: 12px;
          margin-top: 12px;
        }
      }
    }
    .footerCopyInfo{
      font-size:12px;
      color:rgba(230,230,230,1);
      width: 100%;
      text-align: center;
      border-top:1px solid rgba(255,255,255,0.4);
      line-height: 40px;
      position: absolute;
      bottom: 0;
      left: 0;
      .bei{
        color:#fff!important;
        font-size:12px!important;
        &:hover{
          color: #c00!important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue